import moment from "moment";

const API_HOST = process.env.REACT_APP_API_HOST_URL;

const saveFile = async (blob) => {
  const a = document.createElement("a");
  const date = moment().format("YYYYMMDD");
  a.download = `luckyDrawClaims_${date}.csv`;
  a.href = URL.createObjectURL(blob);
  a.addEventListener("click", (e) => {
    setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
  });
  a.click();
};

const exportClaimList = async ({
  luckyDrawUuid,
  token,
  status,
  searchText,
  searchType,
  prizeType,
  claimedDateStart,
  claimedDateEnd,
  wonDateStart,
  wonDateEnd,
  timezone,
  winnerUuids
}) => {
  const body = {
    luckyDrawUuid,
  };

  // Add optional filters if provided
  if (status) body.status = status;
  if (searchText) body.searchText = searchText;
  if (searchType) body.searchType = searchType;
  if (prizeType) body.prizeType = prizeType;
  if (claimedDateStart) body.claimedDateStart = claimedDateStart;
  if (claimedDateEnd) body.claimedDateEnd = claimedDateEnd;
  if (wonDateStart) body.wonDateStart = wonDateStart;
  if (wonDateEnd) body.wonDateEnd = wonDateEnd;
  if (timezone) body.timezone = timezone;
  if (winnerUuids && winnerUuids.length > 0) body.winnerUuids = winnerUuids;

  let response = await fetch(
    `${API_HOST}/campaignV2/customer/luckyDraw/exportClaims`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  );

  let blob = await response.blob();
  saveFile(blob);
};

export default exportClaimList;
